/**
 * Pool immagini editoriali 6amico — asset AI proprietari in /public/img/6amico.
 * Fallback Pexels solo per regioni/mondo dove non c’è ancora asset dedicato.
 */

/** @param {string} file basename senza estensione */
export function aiImage(file) {
  return `/img/6amico/${file}.png`;
}

/** @param {number|string} id @param {number} [w] */
export function pexels(id, w = 800) {
  return `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
}

/** Chiavi tematiche → URL. */
export const SIXAMICO_MEDIA = {
  borghi: aiImage("6amico-borghi"),
  comuni: aiImage("6amico-borghi"),
  /** Hub «Mappa del mondo» — planisfero / rete globale (≠ metropoli). */
  mappaMondo: aiImage("6amico-mappe"),
  mappe: aiImage("6amico-mappe"),
  mappaGlobale: aiImage("6amico-mappe"),
  /** Mappa operativa in loco (sentieri, bici, geofence) — distinta dal collage hub Italia. */
  esploraMappa: aiImage("6amico-tour"),
  podcast: aiImage("6amico-podcast"),
  natura: aiImage("6amico-natura"),
  parchi: aiImage("6amico-natura"),
  mare: aiImage("6amico-mare"),
  mareAdriatico: aiImage("6amico-mare"),
  tour: aiImage("6amico-tour"),
  tourHero: aiImage("6amico-tour"),
  rafting: aiImage("6amico-tour"),
  bike: aiImage("6amico-tour"),
  trekking: aiImage("6amico-tour"),
  terme: aiImage("6amico-terme"),
  termeHero: aiImage("6amico-terme"),
  spa: aiImage("6amico-terme"),
  nautica: aiImage("6amico-nautica"),
  nauticaHero: aiImage("6amico-nautica"),
  porto: aiImage("6amico-nautica"),
  vela: aiImage("6amico-nautica"),
  fiere: aiImage("6amico-community"),
  fiereHero: aiImage("6amico-community"),
  vinitaly: aiImage("6amico-community"),
  designFair: aiImage("6amico-community"),
  travelExpo: aiImage("6amico-community"),
  spiritualita: aiImage("6amico-spiritualita"),
  spiritualitaHero: aiImage("6amico-spiritualita"),
  chiesa: aiImage("6amico-spiritualita"),
  cammino: aiImage("6amico-spiritualita"),
  /** Directory «Città del mondo» — asset dedicato planisfero/rete globale. */
  mondo: aiImage("6amico-mondo-global"),
  gemellaggi: aiImage("6amico-mappe"),
  enogastronomia: aiImage("6amico-vetrina"),
  eventi: aiImage("6amico-eventi"),
  unesco: "/hero/santo-stefano-di-sessanio.jpg",
  montagna: "/hero/campo-imperatore.png",
  slowTravel: aiImage("6amico-tour"),
  gargano: aiImage("6amico-mare"),
  storia: aiImage("6amico-storia"),
  governance: aiImage("6amico-governance"),
  community: aiImage("6amico-community"),
  eventiHub: aiImage("6amico-eventi"),
  weekend: aiImage("6amico-weekend"),
  vetrina: aiImage("6amico-vetrina"),
  mondoGlobal: aiImage("6amico-mondo-global"),
  homeDefault: aiImage("6amico-borghi"),
  // Regioni: foto reali certificate dove disponibili, illustrazioni
  // proprietarie /img/6amico altrove — mai foto duplicate tra regioni.
  regionBasilicata: aiImage("6amico-spiritualita"),
  regionCalabria: aiImage("6amico-eventi"),
  regionCampania: "/images/napoli/napoli-golfo-vomero.jpg",
  regionEmilia: aiImage("6amico-vetrina"),
  regionFriuli: aiImage("6amico-mondo-global"),
  regionLazio: aiImage("6amico-storia"),
  regionLiguria: aiImage("6amico-nautica"),
  regionLombardia: aiImage("6amico-mappe"),
  regionMarche: "/hero/offida.jpg",
  regionMolise: aiImage("6amico-community"),
  regionPiemonte: aiImage("6amico-tour"),
  regionPuglia: aiImage("6amico-weekend"),
  regionSardegna: null,
  regionSicilia: null,
  regionToscana: aiImage("6amico-borghi"),
  regionTrentino: aiImage("6amico-terme"),
  regionUmbria: "/hero/assisi-sacro-convento.jpg",
  regionValleAosta: aiImage("6amico-natura"),
  regionVeneto: aiImage("6amico-mare"),
  worldParis: pexels(2901209, 1600),
  worldTokyo: pexels(2901209, 1600),
  worldNyc: pexels(2901209, 1600),
  worldDubai: pexels(2901209, 1600),
  worldSydney: aiImage("6amico-mare"),
  worldRio: aiImage("6amico-natura"),
  worldCairo: aiImage("6amico-spiritualita"),
  worldBerlin: aiImage("6amico-governance"),
  worldLondon: pexels(2901209, 1600),
};

/** @param {keyof typeof SIXAMICO_MEDIA} key @param {number} [_w] */
export function media(key, _w) {
  return SIXAMICO_MEDIA[key] || SIXAMICO_MEDIA.homeDefault;
}

export const PORTAL_IMAGES_BY_PATH = {
  "/mappa-del-mondo": SIXAMICO_MEDIA.mappaMondo,
  "/comuni": SIXAMICO_MEDIA.borghi,
  "/archivio-podcast": SIXAMICO_MEDIA.podcast,
  "/parchi": SIXAMICO_MEDIA.parchi,
  "/mare-costa": SIXAMICO_MEDIA.mare,
  "/tour-escursioni": SIXAMICO_MEDIA.tour,
  "/terme-benessere": SIXAMICO_MEDIA.terme,
  "/turismo-nautico": SIXAMICO_MEDIA.nautica,
  "/fiere-convegni": SIXAMICO_MEDIA.fiere,
  "/spiritualita": SIXAMICO_MEDIA.spiritualita,
  "/mondo": SIXAMICO_MEDIA.mondoGlobal,
};

export function portalImage(path) {
  return PORTAL_IMAGES_BY_PATH[path] || SIXAMICO_MEDIA.homeDefault;
}
